/* @flow */
import _ from 'lodash';

export default class Mock<TModel> {
  attributes: Backbone$Attrs = {};

  Model: Class<TModel>;

  counter = 0;
  base: ?Function | Object | Array<any>;

  get(...overrides: *[]): TModel {
    // $FlowIssue can't have generic subclass of Entity
    return new this.Model(this.getJSON(...overrides));
  }

  getJSON(...overrides: *[]): Backbone$Attrs {
    this.counter += 1;
    const base = typeof this.base === 'function' ? this.base() : this.base;
    // $FlowFixMe
    this.attributes = Object.assign(Array.isArray(base) ? [] : {}, base);
    _.flatten(overrides).forEach(override => {
      if (typeof override === 'object') {
        const { overrides: overriddenProps, ...others } = override;
        Object.assign(this.attributes, overriddenProps);
        for (const key in others) {
          // $FlowFixMe
          if (typeof this[key] === 'function') {
            if (Array.isArray(base)) {
              this.attributes = this.attributes.concat(this[key].apply(this, [others[key]]));
            } else {
              Object.assign(this.attributes, this[key].apply(this, [others[key]]));
            }
          }
        }
        // $FlowFixMe
      } else if (typeof override === 'string' && typeof this[override] === 'object') {
        if (Array.isArray(base)) {
          this.attributes = this.attributes.concat(this[override]);
        } else {
          Object.assign(this.attributes, this[override]);
        }
      } else {
        throw new Error('Undefined trait: ' + override);
      }
    });

    return this.attributes;
  }

  mockUuid() {
    // $FlowFixMe statics of TModel. Type is incompatible with (unclassified use type: GetStaticsT)
    return `<${this.Model.name}-uuid-${this.counter}>`;
  }
}
